module.exports = __webpack_public_path__ + "static/img/spiral.cbe8e4f9.png";